<template>
  <InputBox
    class="file-input"
    :icon="icon"
    :required="required"
    :error="error"
  >
    <input
      type="file"
      class="file-input__input"
      v-bind="inputAttrs"
      @input="onInput"
    />
    <p class="file-input__placeholder">{{ labelValue }}</p>
    <i class="file-input__icon fa-solid fa-upload"/>
  </InputBox>
</template>

<script setup lang="ts">
import type {InputHTMLAttributes} from "vue";
import type {InputBoxProps} from "@website/components/inputs/InputBox.vue";

const attrs = useAttrs();

export interface Base64File {
  fileName: string,
  base64Encoded: string,
}

export interface FileInputProps extends /* @vue-ignore */ Omit<InputHTMLAttributes, 'required'>, InputBoxProps {
  label: string,
  multiple?: boolean,
}

const props = withDefaults(defineProps<FileInputProps>(), {
  required: false,
});

const inputAttrs = computed(() => {
  const returnObj: any = {}
  for (const attr in attrs) {
    if (attr !== 'class' && attr !== 'value') {
      returnObj[attr] = attrs[attr]
    }
  }
  return returnObj;
})

const labelValue = computed<string>(() => {
  if(!model.value || !model.value?.length)
    return props.label;

  // if(Array.isArray(model.value)) {
  return model.value.length > 1 ? `${model.value[0]!.fileName} + ${model.value.length - 1}` : model.value[0]!.fileName;
  // }
  // return model.value;
})

const model = defineModel<Base64File[] | null>({default: null, required: true,})

async function onInput(event: Event) {
  const target = event.target as HTMLInputElement | null
  if(target?.files == null || target.files.length === 0) {
    model.value = null;
    return;
  }

  model.value = await Promise.all([...target?.files].map<Promise<Base64File>>(async file => ({
    base64Encoded: await fileToBase64(file) as string,
    fileName: file.name,
  })))
}
</script>

<style lang="scss">
.file-input {
  &__input {
    display: none;
  }

  &__placeholder {
    flex-grow: 1;

    color: #212529;
    font-family: var(--font-family-main);
    font-size: 18px;
    font-weight: 500;
  }
}
</style>